import PropTypes from 'prop-types'

function getSnoplowAnalytics(props, context, options) {
  const {analyticsOptions, analyticsContexts, snowplowEvent, overwriteContexts} = props

  return snowplowEvent.analytics(
    analyticsOptions ? analyticsOptions : options,
    overwriteContexts ? analyticsContexts : analyticsContexts.concat(context)
  )
}

const commonPropTypes = {
    analyticsOptions: PropTypes.object,
    analyticsContexts: PropTypes.array,
    snowplowEvent: PropTypes.object,
    overwriteContexts: PropTypes.bool
  },
  commonDefaultProps = {
    analyticsOptions: null,
    analyticsContexts: [],
    overwriteContexts: false
  }

export {getSnoplowAnalytics, commonPropTypes, commonDefaultProps}
